
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/ux/sign-in-screen",
      function () {
        return require("private-next-pages/reference/ux/sign-in-screen.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/ux/sign-in-screen"])
      });
    }
  